import { render, staticRenderFns } from "./found.vue?vue&type=template&id=fdcd7854"
import script from "./found.vue?vue&type=script&lang=js"
export * from "./found.vue?vue&type=script&lang=js"
import style0 from "./found.vue?vue&type=style&index=0&id=fdcd7854&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports